// 获取人员部门组件的自定义的默认值
import { useAccountStore } from '@/stores/modules/account'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { SceneTypeEnum, DynamicConfigEnum } from '@/enums/business'

export function getPersonAnyDepDefaultValue(props: Recordable) {
  let defaultValue: any = null
  const { userInfo } = useAccountStore()
  const { data: columnInfo, sceneType, subFieldFormData } = props

  // 属于人员单、多选组件
  const isPersonComp = [fieldTypeConfig.person, fieldTypeConfig.personMultiple].includes(
    columnInfo.code
  )
  // 属于部门单、多选组件
  const isDepartmentComp = [
    fieldTypeConfig.department,
    fieldTypeConfig.multipleDepartment
  ].includes(columnInfo.code)

  // 设置为当前登录人信息
  const setToLogger = () => {
    if (isPersonComp) {
      userInfo.id && defaultValue.push(userInfo.id)
    }
    if (isDepartmentComp) {
      userInfo?.departmentVO?.id && defaultValue.push(userInfo?.departmentVO?.id)
    }
  }
  // 设置为数据创建人信息
  const setToCreator = () => {
    const { createBy, creatorDepartmentId } = subFieldFormData
    if (isPersonComp) {
      createBy && defaultValue.push(createBy)
    }
    if (isDepartmentComp) {
      creatorDepartmentId && defaultValue.push(creatorDepartmentId)
    }
  }

  try {
    const setting = columnInfo?.setting ? JSON.parse(columnInfo.setting) : {}
    const data = setting?.web?.def?.data || []
    const dynamic = setting?.web?.def?.dynamic || []
    defaultValue = data

    // "当前新增数据的用户(或所属的部门)"选项
    const isAddConfig = dynamic.includes(DynamicConfigEnum.ADD_CONFIG)
    // "当前修改数据的用户(或所属的部门)"选项
    const isEditConfig = dynamic.includes(DynamicConfigEnum.EDIT_CONFIG)

    // 【新增场景】
    if (sceneType === SceneTypeEnum.ADD_FORM) {
      if (isAddConfig || isEditConfig) setToLogger()
    }

    // 【详情-编辑场景】
    if ([SceneTypeEnum.APPLY_DETAIL, SceneTypeEnum.FLOW_DETAIL].includes(sceneType)) {
      if (isAddConfig) setToCreator()
      if (isEditConfig) setToLogger()
    }
  } catch (e) {
    defaultValue = null
  }
  return defaultValue
}
